// extracted by mini-css-extract-plugin
export default {"title":"Title_title__qan5l","activeAnimate":"Title_activeAnimate__nHIMi","ShowTitle":"Title_ShowTitle__UqqrP"};